<ng-container *ngIf="enabled && !readonly">
    <div class="allocation-group--container sku-allocation-container">

      <div class="label color--primary-grey">Allocation Group</div>

      <ng-container *ngIf="{ outOfStock: isOutOfStock$ | async, fetching: fetchingAllocationInventory$ | async } as vm">
        <ng-container *ngIf="!vm.fetching; else loading">
          <div *ngIf="filteredAllocationGroups$ | async; let allocations; else loading">

            <ng-select
              #select
              class="ng-select--custom searchable sku-selector"
              [items]="allocations"
              bindValue="allocation_group_id"
              placeholder="Select Allocation Group"
              [searchable]="true"
              [typeahead]="searchSubject"
              (change)="onSelect($event)"
              [clearable]="false"
              dropdownPosition="bottom"
              [disabled]="isFieldDisabled(vm.outOfStock)"
              [(ngModel)]="selectedInventoryAllocationId"
              notFoundText="No items found"
              typeToSearchText="No items found">
              <ng-template ng-label-tmp let-item="item">
                <span class="d-block font-weight-bold font-5 allocation-group-label">{{ item.allocation_group_label }}</span>
                <span class="d-block font-5">Available: {{  item.available_qty }}</span>
              </ng-template>
              <ng-template ng-option-tmp let-item="item">
                          <span class="d-block font-weight-bold font-6 allocation-group-label">
                              {{ item.allocation_group_label }}
                          </span>
                <span class="d-block font-6">Available: {{ item.available_qty }}</span>
              </ng-template>
            </ng-select>
          </div>
        </ng-container>
      </ng-container>
    </div>

</ng-container>

<ng-template #loading>
    <div class="content-loader small mt-3">
        <div class="inline-loader"></div>
    </div>
</ng-template>
